import React, { ReactElement } from 'react';
import Button from '../Common/Button';
import projectsFeatures from '@Images/projects-features.png';
import './PchNotYet.scss';

const PchNotYet = (): ReactElement => {

    const onLetsTalkClick = () => {
        const win = window.open('https://www.getpacer.com/freeTrial/', '_blank', 'noopener,noreferrer');
        if (win) win.opener = null;
    }

    return (
        <div className='pch-not-yet'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 col-xl-6'>
                        <label>
                            YOU DON&apos;T HAVE ACCESS... YET
                        </label>
                        <h3>
                            The Project Control Hub (PCH) is designed for PMs and leaders to quickly implement a project across many locations/teams.
                        </h3>
                        <p>
                            Think of it as your command center for complex projects. The PCH brings together every moving piece so you can:
                            <ul>
                                <li>Coordinate multiple teams working on the same project.</li>
                                <li>Deploy consistent project checklists across hundreds (or thousands) of locations.</li>
                                <li>Track real-time progress and remove roadblocks before they slow you down.</li>
                            </ul>
                        </p>
                    </div>

                    <div className='col-md-12 col-xl-6 d-flex align-items-center'>
                        <img src={projectsFeatures} className="img-fluid" alt="projects" />
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-12 col-xl-6'>
                        <Button
                            type='button'
                            text='Explore in Demo Mode'
                            bootstrapClass='btn btn-primary'
                            onClick={onLetsTalkClick}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PchNotYet;
